import { rootApi } from "@/services/api/api";
import {
  EventTypes,
  type CalendarControllerPayload,
  type CalendarControllerResponse,
} from "../types";

const calendarApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getCalendarEvents: build.query<CalendarControllerResponse, CalendarControllerPayload>({
      query: (params) => ({
        url: "calendar",
        method: "GET",
        params,
      }),
      transformResponse: (response: CalendarControllerResponse) => ({
        birthdays: response.birthdays.map((event) => ({
          ...event,
          type: EventTypes.BIRTHDAY,
        })),
        anniversaries: response.anniversaries.map((event) => ({
          ...event,
          type: EventTypes.ANNIVERSARY,
        })),
        notes: response.notes.map((event) => ({
          ...event,
          type: EventTypes.NOTE,
        })),
      }),
      providesTags: ["calendarEvent"],
    }),
  }),
});

export const { useGetCalendarEventsQuery } = calendarApi;
